module.exports = __webpack_public_path__ + "img/map-spetema.6f3a2361.svg";